import {UserState, AccountInfo} from '../reducers/user.reducer';
import {safelyToJS} from './utils';

export const selectAccountCountryCode = (state): string =>
    state.getIn(['user', 'accountInfo', 'country']);

export const selectIpCountryCode = (state): string => state.get('ipCountryCode');

export const selectIsLoggedIn = (state): boolean =>
    state.getIn(['user', 'accountInfo', 'isLoggedIn']);

export const selectAccountId = (state): string => state.getIn(['user', 'accountInfo', 'id']);

export const selectDisplayName = (state): string =>
    state.getIn(['user', 'accountInfo', 'displayName']);

export const selectAccountInfo = (state): AccountInfo =>
    state.getIn(['user', 'accountInfo']).toJS();

export const selectUser = (state): UserState => safelyToJS(state.get('user'));
